import React from "react";
import GraphQLHowToStructuredData from "types/seo/graphQLHowToStructuredData";
import HowToStructuredDataSet from "types/seo/howToStructuredDataSet";
const getHowToStructuredDataSetFromData = (
  data: GraphQLHowToStructuredData
): HowToStructuredDataSet => {
  return {
    integrateStructuredDataHowTo: data.integrateStructuredDataHowTo,
    structuredDataHowToQuestion: data.structuredDataHowToQuestion,
    structuredDataHowToLeadImage: data.structuredDataHowToLeadImage,
    structuredDataHowTo: data.structuredDataHowTo,
  };
};

export default getHowToStructuredDataSetFromData;
